
import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const beverageItems = [
  {
    name: 'قهوة عربية أصيلة',
    description: 'قهوة عربية تقليدية محضرة بالحب والهيل',
    price: '12 ريال',
    image: 'https://public.readdy.ai/ai/img_res/b7a395becf29d78e487035bc2c411456.jpg'
  },
  {
    name: 'إسبريسو إيطالي',
    description: 'إسبريسو أصيل محضر من حبوب القهوة الإيطالية المحمصة',
    price: '14 ريال',
    image: 'https://readdy.ai/api/search-image?query=Italian%20espresso%20in%20elegant%20white%20cup%20with%20crema%2C%20luxury%20cafe%20presentation%2C%20professional%20beverage%20photography%20with%20clean%20simple%20white%20background%2C%20rich%20aromatic%20coffee&width=400&height=300&seq=espresso1&orientation=landscape'
  },
  {
    name: 'كابتشينو كلاسيكي',
    description: 'كابتشينو بالحليب المرغي وبودرة الكاكاو',
    price: '16 ريال',
    image: 'https://readdy.ai/api/search-image?query=Classic%20cappuccino%20with%20foamed%20milk%20and%20cocoa%20powder%20in%20elegant%20white%20cup%2C%20luxury%20cafe%20presentation%2C%20professional%20beverage%20photography%20with%20clean%20simple%20white%20background%2C%20creamy%20milk%20foam&width=400&height=300&seq=cappuccino1&orientation=landscape'
  },
  {
    name: 'لاتيه بالفانيليا',
    description: 'لاتيه كريمي بنكهة الفانيليا الطبيعية',
    price: '18 ريال',
    image: 'https://readdy.ai/api/search-image?query=Vanilla%20latte%20with%20creamy%20milk%20and%20natural%20vanilla%20flavor%2C%20elegant%20cafe%20presentation%2C%20professional%20beverage%20photography%20with%20clean%20simple%20white%20background%2C%20smooth%20creamy%20texture&width=400&height=300&seq=latte1&orientation=landscape'
  },
  {
    name: 'عصير برتقال طازج',
    description: 'عصير برتقال طبيعي محضر طازجًا من البرتقال الطازج',
    price: '15 ريال',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20orange%20juice%20in%20elegant%20clear%20glass%20with%20orange%20slices%2C%20luxury%20hotel%20breakfast%20service%2C%20professional%20beverage%20photography%20with%20clean%20simple%20white%20background%2C%20natural%20citrus%20refreshing&width=400&height=300&seq=orange_juice1&orientation=landscape'
  },
  {
    name: 'سموذي الفراولة',
    description: 'سموذي طبيعي بالفراولة الطازجة والحليب',
    price: '22 ريال',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20strawberry%20smoothie%20in%20elegant%20tall%20glass%20with%20fresh%20berries%2C%20healthy%20beverage%20presentation%2C%20professional%20photography%20with%20clean%20simple%20white%20background%2C%20pink%20creamy%20texture&width=400&height=300&seq=strawberry1&orientation=landscape'
  },
  {
    name: 'سموذي المانجو',
    description: 'سموذي استوائي بالمانجو الطازج والزبادي',
    price: '24 ريال',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20mango%20smoothie%20in%20elegant%20tall%20glass%20with%20tropical%20fruits%2C%20healthy%20beverage%20presentation%2C%20professional%20photography%20with%20clean%20simple%20white%20background%2C%20golden%20orange%20color&width=400&height=300&seq=mango1&orientation=landscape'
  },
  {
    name: 'شاي أحمر إنجليزي',
    description: 'شاي أحمر إنجليزي أصيل مع الحليب والسكر',
    price: '10 ريال',
    image: 'https://readdy.ai/api/search-image?query=English%20black%20tea%20in%20elegant%20white%20teacup%20with%20milk%20and%20sugar%2C%20classic%20tea%20service%20presentation%2C%20professional%20beverage%20photography%20with%20clean%20simple%20white%20background%2C%20traditional%20afternoon%20tea&width=400&height=300&seq=black_tea1&orientation=landscape'
  },
  {
    name: 'شاي النعناع المغربي',
    description: 'شاي أخضر بالنعناع الطازج والسكر على الطريقة المغربية',
    price: '11 ريال',
    image: 'https://readdy.ai/api/search-image?query=Moroccan%20mint%20tea%20in%20traditional%20glass%20with%20fresh%20mint%20leaves%2C%20elegant%20Middle%20Eastern%20presentation%2C%20professional%20beverage%20photography%20with%20clean%20simple%20white%20background%2C%20refreshing%20green%20color&width=400&height=300&seq=mint_tea1&orientation=landscape'
  },
  {
    name: 'آيس تي بالليمون',
    description: 'شاي بارد منعش بالليمون الطازج والثلج',
    price: '14 ريال',
    image: 'https://readdy.ai/api/search-image?query=Iced%20tea%20with%20fresh%20lemon%20slices%20in%20tall%20glass%20with%20ice%2C%20refreshing%20summer%20beverage%2C%20professional%20photography%20with%20clean%20simple%20white%20background%2C%20cool%20refreshing%20drink&width=400&height=300&seq=iced_tea1&orientation=landscape'
  },
  {
    name: 'شوكولاتة ساخنة فاخرة',
    description: 'شوكولاتة ساخنة غنية مع الكريمة المخفوقة',
    price: '18 ريال',
    image: 'https://readdy.ai/api/search-image?query=Rich%20hot%20chocolate%20with%20whipped%20cream%20in%20elegant%20white%20mug%2C%20luxury%20winter%20beverage%20presentation%2C%20professional%20photography%20with%20clean%20simple%20white%20background%2C%20creamy%20indulgent%20drink&width=400&height=300&seq=hot_chocolate1&orientation=landscape'
  },
  {
    name: 'مياه منكهة بالخيار',
    description: 'مياه طبيعية منكهة بشرائح الخيار الطازج',
    price: '10 ريال',
    image: 'https://readdy.ai/api/search-image?query=Cucumber%20infused%20water%20in%20elegant%20clear%20glass%20with%20fresh%20cucumber%20slices%2C%20healthy%20hydrating%20beverage%2C%20professional%20photography%20with%20clean%20simple%20white%20background%2C%20refreshing%20spa%20water&width=400&height=300&seq=cucumber_water1&orientation=landscape'
  }
];

export default function Beverages() {
  const [scrolled, setScrolled] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar scrolled={scrolled} />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 bg-gradient-to-r from-amber-600 to-amber-700">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Cairo, sans-serif' }}>
            الكافي والمشروبات
          </h1>
          <p className="text-xl text-amber-100 max-w-3xl mx-auto mb-8">
            استمتع بأفضل أنواع القهوة والمشروبات في أي وقت من اليوم
          </p>
          <div className="inline-flex items-center gap-3 bg-white/20 rounded-full px-6 py-3 text-white">
            <i className="ri-time-line text-2xl"></i>
            <span className="text-lg font-semibold">متوفر على مدار ٢٤ ساعة</span>
          </div>
        </div>
      </section>

      {/* Menu Items */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {beverageItems.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                
                <div className="p-6">
                  <div className="flex justify-between items-start mb-3">
                    <h3 className="text-xl font-bold text-gray-900" style={{ fontFamily: 'Cairo, sans-serif' }}>
                      {item.name}
                    </h3>
                    <span className="text-2xl font-bold text-amber-600">
                      {item.price}
                    </span>
                  </div>
                  <p className="text-base text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-16">
            <div className="inline-block bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center gap-4 justify-center mb-4">
                <i className="ri-information-line text-3xl text-amber-600"></i>
                <h3 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Cairo, sans-serif' }}>
                  معلومات إضافية
                </h3>
              </div>
              <div className="space-y-3 text-gray-700">
                <p className="text-lg"><strong>الخدمة:</strong> متوفرة في اللوبي والغرف والمطعم</p>
                <p className="text-lg"><strong>التوصيل:</strong> خدمة توصيل مجاني للغرف</p>
                <p className="text-lg"><strong>العروض الخاصة:</strong> هابي آور يوميًا من 3-5 مساءً</p>
                <p className="text-sm text-amber-600 font-semibold mt-4">* الأسعار للعرض فقط وقابلة للتغيير</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
